<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loading"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="records_count"
				:loading-info="loading"
				:showOrderBy="true"
				items-type="serials"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				ref="table"
				:headers="headers"
				:items="records"
				item-key="id"
				:loading="loading"
				:server-items-length="records_count"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				style="overflow-x: scroll;"
				:class="$vuetify.breakpoint.mobile ? '':'resizable'"
				disable-sort
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:header.reports="{ header }">
					<div class="pt-2">
						<b>{{ header.text }}</b>
						<v-divider></v-divider>
						<table style="width: 100%;border-collapse: collapse;">
							<tr>
								<th :style="index + 1 == reportPrefixes.length ? 'border-right-width: 0;':''" v-for="(report_prefix,index) in reportPrefixes" :key="'bp_' + report_prefix.id" class="pa-0">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="pa-1" v-bind="attrs" v-on="on">{{ report_prefix.prefix }} <v-icon x-small>mdi-information-slab-circle-outline</v-icon></div>
										</template>
										<span>{{ report_prefix.name }}</span>
									</v-tooltip>
									<v-divider></v-divider>
									<table style="width: 100%;border-collapse: collapse;">
										<tr>
											<th style="width: 150px;">Nº</th>
											<th style="width: 80px;border-right-width:0;">Fecha</th>
										</tr>
									</table>
								</th>
							</tr>
						</table>
					</div>
				</template>
				<template v-slot:header.budgets="{ header }">
					<div class="pt-2">
						<b>{{ header.text }}</b>
						<v-divider></v-divider>
						<table style="width: 100%;border-collapse: collapse;">
							<tr>
								<th :style="index + 1 == budgetPrefixes.length ? 'border-right-width: 0;':''" v-for="(budget_prefix,index) in budgetPrefixes" :key="'bp_' + budget_prefix.id" class="pa-0">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="pa-1" v-bind="attrs" v-on="on">{{ budget_prefix.prefix }} <v-icon x-small>mdi-information-slab-circle-outline</v-icon></div>
										</template>
										<span>{{ budget_prefix.name }}</span>
									</v-tooltip>
									<v-divider></v-divider>
									<table style="width: 100%;border-collapse: collapse;">
										<tr>
											<th style="width: 120px;">Nº</th>
											<th style="width: 80px;border-right-width:0;">Fecha</th>
										</tr>
									</table>
								</th>
							</tr>
						</table>
					</div>
				</template>
				<template v-slot:item.id="{ item }">
					<div class="d-flex flex-column align-center">
						<p class="mb-0 font-weight-bold">{{item.serial}}</p>
					</div>
				</template>
				<template v-slot:item.lp_id="{ item }">
					<div>
						<div class="d-flex align-center">
							<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project?.project_line_info?.project_line?.number }}</p>
							<ProjectLineAssociationMenu :projectLineAssociations="item.project?.associations" :btnClick="() => selectRow(item)"/>
						</div>
						<div class="d-flex align-center">
							<ProjectLineAssociationIcons :projectLineAssociations="item.project?.associations" />
						</div>
					</div>
				</template>
				<template v-slot:header.contracts="{ header }">
					<div class="d-flex flex-column flex-grow-1 align-center justify-center fill-height pt-2">
						<div class="flex-grow-1 d-flex fill-height">
							<b>{{ header.text }}</b>
						</div>
						<v-divider></v-divider>
						<table style="width: 100%;border-collapse: collapse;">
							<tr>
								<th style="border-right-width: 0;" class="pa-0">
									<!-- <div class="pa-0 red">asdas</div> -->
									<v-divider></v-divider>
									<table style="width: 100%;border-collapse: collapse;">
										<tr>
											<th :class="{ 'with-addendum': hasAddendums }">Nº</th>
											<th style="width: 80px;border-right-width: 0;">Fecha</th>
										</tr>
									</table>
								</th>
							</tr>
						</table>
					</div>
				</template>
				<template v-slot:item.client="{ item }">
					<div>
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ clientName(item) }}</b>
							<div>{{ item.project?.client ? item.project.client.email:'No identificado'}}</div>
						</div>
					</div>
					<div class="d-flex justify-end">
						<v-chip
							color="green"
							label
							outlined
							x-small
							class="ml-1"
							v-if="item.reports.length > 0 && item.reports.some(report => report.id == last_report_id)"
						>
							<b>Último Informe</b>
						</v-chip>
						<v-chip
							color="green"
							label
							outlined
							x-small
							class="ml-1"
							v-if="item.budgets.length > 0 && item.budgets.some(budget => budget.id == last_budget_id)"
						>
							<b>Último Presupuesto</b>
						</v-chip>
						<v-chip
							color="green"
							label
							outlined
							x-small
							class="ml-1"
							v-if="item.contracts.length > 0 && item.contracts.some(contract => contract.id == last_contract_id)"
						>
							<b>Último Contrato</b>
						</v-chip>
						<!-- <v-tooltip bottom v-if="item.reports.length > 0 && item.reports.some(report => report.id == last_report_id)">
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="green"
									class="ml-1"
									v-bind="attrs"
									v-on="on">mdi-file-document-outline</v-icon>
							</template>
							<span>Último Informe Creado</span>
						</v-tooltip>
						<v-tooltip bottom v-if="item.budgets.length > 0 && item.budgets.some(budget => budget.id == last_budget_id)">
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="green"
									class="ml-1"
									v-bind="attrs"
									v-on="on">mdi-book-outline</v-icon>
							</template>
							<span>Último Presupuesto Creado</span>
						</v-tooltip>
						<v-tooltip bottom v-if="item.contracts.length > 0 && item.contracts.some(contract => contract.id == last_contract_id)">
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="green"
									class="ml-1"
									v-bind="attrs"
									v-on="on">mdi-briefcase-outline</v-icon>
							</template>
							<span>Último Contrato Creado</span>
						</v-tooltip> -->
						<v-tooltip bottom v-if="item.project?.client?.company_profile && item.project?.client?.accreditation?.status">
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="#FF1209"
									class="ml-1"
									v-bind="attrs"
									v-on="on">mdi-domain</v-icon>
							</template>
							<span>Cliente Empresa</span>
						</v-tooltip>
						<v-tooltip bottom v-else>
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="#959595"
									class="ml-1"
									v-bind="attrs"
									v-on="on">mdi-account</v-icon>
							</template>
							<span>Cliente Persona Natural</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.project="{ item }">
					<p class="mb-0 font-weight-bold">{{ getProjectName(item) }}</p>
					<!-- <div class="d-flex align-start justify-start">
						<div>
							<p class="mb-0 mr-2">Asociaciones</p>
						</div>
						<ProjectLineAssociationMenu :projectLineAssociations="item.project?.associations" :btnClick="() => selectRow(item)"/>
					</div> -->
				</template>
				<template v-slot:item.budgets="{ item }">
					<table class="fill-height" style="width: 100%;border-collapse: collapse;">
						<tr>
							<td style="border-right-width: 0;" class="px-0 py-0 fill-height" v-for="(budget_prefix, ind) in budgetPrefixes" :key="'bp2_' + budget_prefix.id">
								<table class="fill-height custom-table-serials-content" style="width: 100%;border-collapse: collapse;">
									<tr>
										<td class="px-1" style="width: 120px;">
											<div v-for="budget in item.budgets" :key="'b_' + budget.id">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															text
															x-small
															color="#FF120B"
															class="mb-0 caption font-weight-bold px-1" 
															v-bind="attrs"
															v-on="on"
															@click.stop="() => { selectRow(item); toBudget(budget); }"
															v-if="budget.prefix?.id === budget_prefix.id">
																{{ item.serial }} - LP{{ item.project?.project_line_info?.project_line?.number }} - {{ budget.prefix?.prefix }} {{ budget.info?.budget_prefix_index }}
															</v-btn>
													</template>
													<div>
														<p class="mb-0 font-weight-bold caption">Presupuesto</p>
														<p class="mb-0 font-weight-bold" style="font-size: 10px;">Formato Código: Línea de Proyecto - Prefijo Número de Serie - Año</p>
													</div>
												</v-tooltip>
											</div>
										</td>
										<td class="px-1" :style="ind + 1 == budgetPrefixes.length ? 'border-right-width:0':''" style="width: 80px;">
											<div v-for="budget in item.budgets" :key="'b2_' + budget.id">
												<p class="mb-0 caption" v-if="budget.prefix?.id === budget_prefix.id">{{ budget.created_at | toDate }}</p>
											</div>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</template>
				<template v-slot:item.reports="{ item }">
					<table class="fill-height" style="width: 100%;border-collapse: collapse;">
						<tr>
							<td style="border-right-width: 0;" class="px-0 py-0 fill-height" v-for="(report_prefix, ind) in reportPrefixes" :key="'bp2_' + report_prefix.id">
								<table class="fill-height custom-table-serials-content" style="width: 100%;border-collapse: collapse;">
									<tr>
										<td class="px-1" style="width: 150px;">
											<div v-for="report in item.reports" :key="'b_' + report.id">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															text
															x-small
															color="#FF120B"
															class="mb-0 caption font-weight-bold px-1"
															v-bind="attrs"
															v-on="on"
															@click.stop="() => { selectRow(item); toReportDetail(report); }"
															v-if="report.prefix?.id === report_prefix.id">
																{{ item.serial }} - LP{{ item.project?.project_line_info?.project_line?.number }} - {{ report.prefix?.prefix }} {{ report.report_index }}
														</v-btn>
													</template>
													<div>
														<p class="mb-0 font-weight-bold caption">Informe</p>
														<p class="mb-0 font-weight-bold" style="font-size: 10px;">Formato Código: Línea de Proyecto - Prefijo Número de Serie - Año</p>
													</div>
												</v-tooltip>
											</div>
										</td>
										<td class="px-1" :style="ind + 1 == reportPrefixes.length ? 'border-right-width:0':''" style="width: 80px;">
											<div v-for="report in item.reports" :key="'b2_' + report.id">
												<p class="mb-0 caption" v-if="report.prefix?.id === report_prefix.id">{{ report.created_at | toDate }}</p>
											</div>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</template>
				<!-- <template v-slot:item.reports="{ item }">
					<table class="fill-height" style="width: 100%;border-collapse: collapse;">
						<tr>
							<td style="border-right-width: 0;" class="py-0 fill-height">
								<table class="fill-height custom-table-serials-content" style="width: 100%;border-collapse: collapse;">
									<tr v-if="item.reports?.length >= 0">
										<td>
											<div v-for="report in item.reports" :key="'re_' + report.id">
												<v-btn
													text
													x-small
													color="#FF120B"
													class="mb-0 caption font-weight-bold" 
													@click.stop="() => { selectRow(item); toReportDetail(report)"; }>
														{{ report.prefix?.prefix }} {{ item.serial }} - {{ report.created_at | toYear }}
													</v-btn>
											</div>
										</td>
										<td style="border-right-width: 0;">
											<div v-for="report in item.reports" :key="'re2_' + report.id">
												<p class="mb-0 caption">{{ report.created_at | toDate }}</p>
											</div>
										</td>
									</tr>
									<tr v-else>
										<td><p class="mb-0 caption">--</p></td>
										<td style="border-right-width: 0;"><p class="mb-0 caption">--</p></td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</template> -->
				<template v-slot:item.contracts="{ item }">
					<table class="fill-height" style="width: 100%;border-collapse: collapse;">
						<tr>
							<td style="border-right-width: 0;" class="pa-0 fill-height">
								<table class="fill-height custom-table-serials-content" style="width: 100%;border-collapse: collapse;">
									<tr v-if="item.contracts?.length >= 0">
										<td class="px-1" :class="{ 'with-addendum': hasAddendums }">
											<div v-for="contract in item.contracts" :key="'ct_' + contract.id">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															text
															x-small
															:color="contract.addendum_to_contract_id || contract.subcontract_to_contract_id ? '#959595':'#FF120B'"
															class="mb-0 caption font-weight-bold" 
															@click.stop="() => { selectRow(item); toContractDetail(contract); }"
															v-bind="attrs"
															v-on="on">
															{{ item.serial }} - LP{{ item.project?.project_line_info?.project_line?.number }} - {{ contract.prefix?.prefix }} {{ getContractPrefixIndex(contract) }} {{ getContractSuffix(contract) }}
															<!-- <span v-if="contract.addendum_to_contract_id">
																{{ item.serial }} - LP{{ item.project?.project_line_info?.project_line?.number }} - {{ contract.prefix?.prefix }} X - ANX Nº {{ contract.addendum_index }}
															</span>
															<span v-else>
																{{ item.serial }} - LP{{ item.project?.project_line_info?.project_line?.number }} - {{ contract.prefix?.prefix }} X
															</span> -->
														</v-btn>
													</template>
													<div>
														<p class="mb-0 font-weight-bold caption">{{contract.addendum_to_contract_id ? 'Anexo de Contrato':'Contrato'}}</p>
														<p class="mb-0 font-weight-bold" style="font-size: 10px;">Formato Código: Línea de Proyecto - Prefijo Número de Serie - Año</p>
													</div>
												</v-tooltip>
											</div>
										</td>
										<td class="px-1" style="border-right-width: 0;width: 80px;">
											<div v-for="contract in item.contracts" :key="'ct2_' + contract.id">
												<p class="mb-0 caption">{{ contract.created_at | toDate }}</p>
											</div>
										</td>
									</tr>
									<tr v-else>
										<td><p class="mb-0 caption">--</p></td>
										<td style="border-right-width: 0;"><p class="mb-0 caption">--</p></td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="records_count"
				:loading-info="loading"
				:showOrderBy="true"
				items-type="serials"
			/>
		</div> -->
	</v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { getSerials } from '@/helpers/api/budgets'
import {getReportById} from '@/helpers/api/reports'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'

export default {
	name: 'ProjectsSerialsTable',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons
	},
	data() {
		return {
			selectedRowItem: null,
			loading: false,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
				order_by: localStorage.getItem('serials_order_by') ? parseInt(localStorage.getItem('serials_order_by')) : 1,
      },
			records: [],
			records_count: 0,
			budget_prefixes: [],
			last_contract_id: null,
			last_budget_id: null,
			last_report_id: null
		}
	},
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		budgetPrefixes(){
			// let budgets = this.budget_prefixes.map((prefix) => {
			// 	if(!this.$store.state.budget.listingColumns['vt_budget'] && prefix.id == 6){
			// 		return false
			// 	}
			// 	if(!this.$store.state.budget.listingColumns['pp_budget'] && prefix.id == 5){
			// 		return false
			// 	}
			// 	if(prefix.type == 'budget'){
			// 		return prefix.id
			// 	}
			// })
			// return this.budget_prefixes.filter(prefix => budgets.includes(prefix.id))
			return this.budget_prefixes.filter(prefix => prefix.type == 'budget' && this.$store.state.budget.listingColumns.variable?.includes(prefix.id))
		},
		reportPrefixes(){
			// let reports = []
			// if(this.$store.state.budget.listingColumns['vt_report']){
			// 	reports.push(7)
			// }
			// if(this.$store.state.budget.listingColumns['pp_report']){
			// 	reports.push(8)
			// }
			// if(this.$store.state.budget.listingColumns['pr_report']){
			// 	reports.push(9)
			// }
			
			return this.budget_prefixes.filter(prefix => prefix.type == 'report' && this.$store.state.budget.listingColumns.variable?.includes(prefix.id))
		},
		hasAddendums() {
			return this.records.some(item =>
				item.contracts?.some(contract => contract.addendum_to_contract_id != null)
			);
		},
		headers(){
			let headers = [
				{ text: 'Nº Serie', value: 'id', width: '55px', align: 'center', sortable: false },
				{ text: 'Línea de Proyecto', value: 'lp_id', width: '70px', align: 'center', sortable: false },
				{ text: 'Cliente', value: 'client', align: 'start', width: '20%', sortable: false },
				{ text: 'Proyecto', value: 'project', align: 'start', width: '20%', sortable: false },
				{ text: 'Informes', value: 'reports', align: 'center', sortable: false, class: 'custom-project-header-class', cellClass: 'custom-project-header-class' },
				{ text: 'Presupuestos', value: 'budgets', align: 'center', sortable: false, class: 'custom-project-header-class', cellClass: 'custom-project-header-class' },
				{ text: 'Contratos', value: 'contracts', align: 'center', sortable: false, class: 'custom-project-header-class', cellClass: 'custom-project-header-class' }
			]
			return headers.filter((header) => {
				return this.$store.state.budget.listingColumns[header.value]
			})
		},
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		},
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
	},
	mounted() {
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_serialslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
	methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_serialslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		getContractPrefixIndex(contract){
			const parent = contract.addendum_parent || contract.subcontract_parent
			if(parent){
				return parent.info?.contract_prefix_index
			}
			return contract.info?.contract_prefix_index
		},
		getContractSuffix(contract){
			if (contract.addendum_to_contract_id) {
				return ` - ANX Nº ${contract.addendum_index}`;
			}
			else if (contract.subcontract_to_contract_id) {
				return ` - SUB Nº ${contract.subcontract_index}`;
			}
			return '';
		},
		contractsOrdered(contracts){
			let counter = 1;
			return contracts.map(contract => {
				if (contract.addendum_to_contract_id !== null) {
					return {
						...contract,
						addendum_index: counter++
					};
				}
				return contract;
			})
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		projectLineAssociations(item){
			if(item.project?.associations?.associations){
				const project_associations = item.project?.associations
				return project_associations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		needToShowProject(item){
			item.project?.associations?.some((association) => {
				return association.project_type != 'Project'
			})
		},
		getProjectName(item){
			if(item.project?.name){
				return item.project?.name
			}
			else if(item.project?.info?.project_detail){
				return item.project?.info?.project_detail
			}
			return '--'
		},
		clientName(item){
			let client_name = 'No Disponible'
			if(item.project?.client?.profile){
				client_name = item.project.client.profile.name + ' ' + item.project.client.profile.lastname + ' ' + item.project.client.profile.second_lastname
			}
			else if(this.getType(item.project_type) == 'crm' && item.project?.user){
				client_name = (item.project.user.name ?? '') + ' ' +
											(item.project.user.lastname ?? '') + ' ' +
											(item.project.user.second_lastname ?? '')
			}
			return client_name
		},
		async reloadInfo() {
			this.loading = true
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			const records = await getSerials(data)
			if(records.code === 200){
				this.records = records.records
				this.budget_prefixes = records.budget_prefixes
				this.records_count = records.records_count
				this.last_contract_id = records.last_contract_id
				this.last_budget_id = records.last_budget_id
				this.last_report_id = records.last_report_id
			}
			else{
				this.$store.commit('snackbar/setSnackbar', {
					show: true,
					text: 'Error al cargar los datos',
					color: 'error'
				})
			}
			this.loading = false
		},
		toBudget(budget){
			localStorage.setItem('last_working_budget', JSON.stringify(budget))
			this.$store.commit('budget/setBudgetComponentModalId', budget.id)
			// this.$router.push({ name: 'BudgetDetail', query: { id: budget.id } })
		},
		toContractDetail(contract){
			if(contract.addendum_to_contract_id){
				this.$store.commit('contracts/setContractAddendumComponentModalId', contract.id)
			}
			else if(contract.subcontract_to_contract_id){
				this.$store.commit('contracts/setSubcontractComponentModalId', contract.id)
			}
			else{
				this.$store.commit('contracts/setContractComponentModalId', contract.id)
			}
			// this.$router.push({ name: 'ContractDetail', query: { id: contract.id } })
		},
		toReportDetail(report){
			this.$store.commit('reports/setReportComponentModalId', {report_id:report.id, status: true})
			// this.getReport(report.id)
			// this.$router.push({ name: 'ReportDetail', query: { id: report.id } })
		},
		async getReport(report_id){
			const report = await getReportById({report_id})
			if(report.code == 200){
				this.$store.commit('reports/setReportComponentModalId', report.report)
			}
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				// this.$router.push({ name: 'PreProject', params: { id: association.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				// this.$router.push({ name: 'Conversation', params: { id: association.morphable_id } })
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
		getTypeIcon(type){
			switch (type) {
				case "crm":
					return 'mdi-contacts-outline'
				case "preproject":
					return 'mdi-information-variant-circle-outline'
				case "project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "crm":
					return 'CRM'
				case "preproject":
					return 'PreProyecto'
				case "project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		getType(type){
			switch (type) {
				case "crm":
					return 'crm'
				case "preproject":
					return 'preproject'
				case "project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
	},
}
</script>

<style>
	.custom-project-header-class{
		padding: 0 !important;
	}
	table.custom-table-serials-content {
		table-layout: fixed;
		width: 100%;
	}

	table.custom-table-serials-content td {
		width: 110px;
		border-right: none;
	}

	table.custom-table-serials-content td.with-addendum,
	table th.with-addendum {
		width: 170px!important;
	}
	.crm-table table .custom-project-header-class{
		border-right-width: 0;
		border-collapse: collapse;
	}
</style>